import { render, staticRenderFns } from "./Realizacao.vue?vue&type=template&id=cab1b4b2"
import script from "./Realizacao.vue?vue&type=script&lang=js"
export * from "./Realizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports